<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

const emits = defineEmits(["updateFilter"])

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const ratings = ref([5, 4, 3, 2, 1, 0])

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

const onClickRating = (value: number) => {
    emits("updateFilter", value)
}
</script>

<template>
    <div class="tw-flex tw-flex-col tw-gap-2">
        <template v-for="rating in ratings" :key="rating">
            <q-rating
                v-model="ratings[ratings.length - rating - 1]"
                :value="rating"
                max="5"
                readonly
                size="20px"
                class="tw-text-[#E4B200]"
                @click="onClickRating(rating)"
            />
        </template>
    </div>
</template>

<style scoped></style>
